import React, { useState, lazy } from 'react';
import type { Brand } from '../constants/brands';
type Props = {
  brand: Brand;
  /** Show the brand name as a label below the logo. */
  showLabel?: boolean;
  /** Optional override for tighter / looser cards. */
  size?: 'sm' | 'md';
};
export function BrandLogoCard({
  brand,
  showLabel = true,
  size = 'md'
}: Props) {
  const [imgFailed, setImgFailed] = useState(false);
  const cardClasses = brand.dark ? 'bg-brand-hunter border-brand-hunter/40 hover:border-brand-leather' : 'bg-brand-offwhite border-brand-bone hover:border-brand-leather';
  const labelClasses = brand.dark ? 'text-brand-offwhite/80' : 'text-brand-charcoal/75';
  const logoHeight = size === 'sm' ? 'h-10 md:h-12' : 'h-12 md:h-14';
  return <div className={`group flex flex-col items-center justify-center rounded-sm border ${cardClasses} px-4 py-6 transition-colors`} data-id="element-47">
      <div className="flex-1 w-full flex items-center justify-center min-h-[3.5rem]" data-id="element-48">
        {imgFailed ? <span className={`font-serif text-lg md:text-xl text-center ${brand.dark ? 'text-brand-offwhite' : 'text-brand-charcoal'}`} data-id="element-49">
            {brand.name}
          </span> : <img src={brand.src} alt={brand.alt} loading="lazy" onError={() => setImgFailed(true)} className={`w-auto ${logoHeight} max-w-[80%] object-contain`} data-id="element-50" />}
      </div>
      {showLabel && !imgFailed && <span className={`mt-4 text-xs font-medium uppercase tracking-wider ${labelClasses}`} data-id="element-51">
          {brand.name}
        </span>}
    </div>;
}